import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _Promise from "babel-runtime/core-js/promise";
import _extends from "babel-runtime/helpers/extends";
import axios from "axios";

// import cookie from "@/utils/cookie";

// var instance = axios.create({
//   // baseURL: "http://localhost:3000/api",
//   // dev
//   baseURL: "https://coding.jiker.com/api"
//   // commit
//   // baseURL: "/api"
// });

const instance = axios.create({
  baseURL: "/api"
});

// axios.defaults.withCredentials = true;
// instance.defaults.timeout = 20000;
// instance.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// 添加一个请求拦截器（ 一般用于鉴权 )
instance.interceptors.request.use(
  function(config) {
    // 根据参数转发
    if (config.urlReplace) {
      config.baseURL = config.urlReplace;
    }
    var newConfig = _extends({}, config);
    // const user = cookie.get('user_id');
    // if(newConfig.method === 'get' && newConfig.params) newConfig.params.attendantUuid = user;
    // if(newConfig.method === 'post' && newConfig.data) newConfig.data.attendantUuid = user;
    newConfig.headers.Accept = 'application/x.api.v1+json';
    return newConfig;
  },
  function(error) {
    return _Promise.reject(error);
  }
);

// 全局错误处理
var handleErrorRequest = function handleErrorRequest(error) {
  var response = error.response;

  var status = response ? response.status : 408;

  if (response) {
    var data = response.data;
    var errors = data.errors;

    var message = data.message || data.msg || "服务器发送错误，请稍后再试";
    if (status === 401) {
      // Message.error(message);
      DataStore.clear();
    } else if (status === 419) {
      // console.log('页面过期');
      DataStore.clear();
    } else if (status === 422 || status === 423 || status === 429) {
      _Object$keys(errors).forEach(function(errorKey) {
        var errorValue = errors[errorKey].join("\n");
        _Message.error(errorValue);
      });
      // } else if (status === 408) {
    } else {
      _Message.error(message);
    }
  } else {
    _Message.error("网络超时");
  }
};

// 添加响应拦截器
instance.interceptors.response.use(
  function(res) {
    // 兼容包了一层 { code, data, msg } 的情况
    var _res$data = res.data,
      code = _res$data.code,
      data = _res$data.data,
      msg = _res$data.msg;

    if (code) {
      if (code !== 200 && code !== 2000) {
        if (!res.config.noError) {
          _Message.error(msg);
        }
        return _Promise.reject(data);
      }
    }
    if (res.data.error_code) {
      if (res.config.method !== "get") {
        _Message.error(res.data.msg);
      }
      return _Promise.reject(res.data);
    }
    if (res.data.code) {
      if ([200, 2000].includes(res.data.code)) return res.data.data;
      if (res.config.method !== "get") {
        _Message.error(res.data.msg);
      }
      return _Promise.reject(res.data);
    }
    if (res.data.error_code !== undefined) {
      return res.data;
    }
    return res.data;
  },
  function(error) {
    handleErrorRequest(error);
    // console.log(error.response.data);
    return _Promise.reject(error.response.data);
  }
);

/* [请求库]
 ** @params url         { string }   @default => '' [接口地址，统一在global/resource文件中]
 ** @params data/params { object }   @default => {} [发送数据]
 ** @params config      { object }   配置
 */
export default {
  dealUrl: function dealUrl(url) {
    return new _Promise(function(resolve) {
      if (url.indexOf("{companyId}") > -1) {
        var id = companyContext.value.id;

        if (id) {
          resolve(url.replace("{companyId}", id));
        } else {
          companyContext.listen(function(res) {
            resolve(url.replace("{companyId}", res.id));
          });
        }
        return;
      }
      resolve(url);
    });
  },
  post: function post() {
    var url =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var _this = this;

    var data =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return new _Promise(function(resolve, reject) {
      _this.dealUrl(url).then(function(res) {
        return instance.post(res, data, config).then(resolve, reject);
      });
    });
  },
  put: function put() {
    var url =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    var _this2 = this;

    var data =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return new _Promise(function(resolve, reject) {
      _this2.dealUrl(url).then(function(res) {
        return instance.put(res, data, config).then(resolve, reject);
      });
    });
  },
  get: function get(url) {
    var _this3 = this;

    var params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var OPTIONS = _extends({ params: params }, config);
    return new _Promise(function(resolve, reject) {
      _this3.dealUrl(url).then(function(res) {
        return instance.get(res, OPTIONS).then(resolve, reject);
      });
    });
  },
  delete: function _delete() {
    var url =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    var _this4 = this;

    var params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var OPTIONS = _extends({ params: params }, config);
    return new _Promise(function(resolve, reject) {
      _this4.dealUrl(url).then(function(res) {
        return instance.delete(res, OPTIONS).then(resolve, reject);
      });
    });
  },
  download: function download() {
    var url =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var token = DataStore.getToken();
    var downUrl = common.assembleUrlQuery(
      "" + process.env.VUE_APP_BASE_URL + url,
      _extends({}, params, { download: null, token: token })
    );
    window.location.href = downUrl;
  }
};
